import React from 'react'
import { useNavigate } from 'react-router-dom'
import { usePermissions } from '../hooks/usePermissions'

interface RouteGuardProps {
    children: React.ReactNode
    requiredPermission?: string | string[]
    fallback?: React.ReactNode
}

export const RouteGuard: React.FC<RouteGuardProps> = ({
    children,
    requiredPermission,
}) => {
    const { can } = usePermissions()
    const navigate = useNavigate()

    if (requiredPermission === undefined) {
        return <>{children}</>
    }

    const hasAccess = can(requiredPermission)

    if (hasAccess === false) {
        navigate('/orders')
        return null
    }

    return <>{children}</>
}
export default RouteGuard
